import React, { useState } from "react";
import { StyledText } from "../assets/typography/typography";
import InlineEdit from "../module/common/InlineEdit";
import { colors } from "./colors";

interface EditableDetailsRowProps extends React.HTMLAttributes<HTMLDivElement> {
  leftText: string | undefined | null;
  leftTextFont?: string;
  leftTextColor?: string;
  defaultValue: string;
  fieldName: string;
  onlineEdit: (fieldName: string, valeu: string) => Promise<boolean>;
  selectOptions?: { label: string; value: string }[];
  type?: "text" | "select";
}

export const EditableDetailsRow = ({
  leftText,
  className,
  leftTextFont,
  leftTextColor,
  defaultValue,
  onlineEdit,
  fieldName,
  selectOptions,
  type,
  ...rest
}: EditableDetailsRowProps) => {
  const [showEdit, setShowEdit] = useState<boolean>(false);

  return (
    <div
      className={`row ${className || ""}`}
      {...rest}
      onMouseEnter={() => setShowEdit(true)}
      onMouseLeave={() => setShowEdit(false)}
    >
      <div className="col d-flex flex-col align-items-center">
        <StyledText
          color={leftTextColor || colors.textSecondary}
          className={`mb-0 ${leftTextFont || "bodyTextRegular"}`}
        >
          {leftText ? leftText : "-"}
        </StyledText>
      </div>
      <div className="col d-flex flex-row align-items-center justify-content-end">
        <InlineEdit
          showEdit={showEdit}
          defaultValue={defaultValue}
          type={type ?? "text"}
          fieldName={fieldName}
          onSubmit={onlineEdit}
          selectOptions={selectOptions}
        />
      </div>
    </div>
  );
};
